import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#F5F6F6]">
      <Header />
      <main className="max-w-2xl mx-auto px-6 lg:px-8 py-24 text-center" data-testid="not-found-page">
        <div className="font-display text-7xl font-bold text-[#965EA7]">404</div>
        <h1 className="mt-3 font-display text-2xl md:text-3xl font-bold text-[#373A45]">
          Pagina nu a fost găsită
        </h1>
        <p className="mt-3 text-[#6B7280]">Linkul este invalid sau pagina a fost mutată.</p>
        <Link
          to="/"
          className="mt-8 inline-flex rounded-full bg-[#965EA7] hover:bg-[#7A4986] text-white font-semibold px-6 py-3"
          data-testid="not-found-home"
        >
          Înapoi la pagina principală
        </Link>
      </main>
      <Footer />
    </div>
  );
}
